/**
 * DonutChart — Donut SVG para Taxa de Adesão
 */
interface DonutChartProps {
  percentage: number; // 0-100
  completed: number;
  total: number;
  label?: string;
  size?: number;
  color?: string;
}

export default function DonutChart({ percentage, completed, total, label = "Taxa de Adesão", size = 160, color = "#0D7377" }: DonutChartProps) {
  const radius = size * 0.35;
  const circumference = 2 * Math.PI * radius;
  const strokeDasharray = circumference;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;
  const cx = size / 2;
  const cy = size / 2;
  const strokeWidth = size * 0.08;

  return (
    <div className="flex flex-col items-center">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        {/* Background circle */}
        <circle cx={cx} cy={cy} r={radius} fill="none" stroke="#E5E7EB" strokeWidth={strokeWidth} />
        {/* Value arc */}
        <circle
          cx={cx} cy={cy} r={radius}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeDasharray={strokeDasharray}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          transform={`rotate(-90 ${cx} ${cy})`}
        />
        {/* Center text */}
        <text x={cx} y={cy - 6} textAnchor="middle" className="font-bold" style={{ fontSize: size * 0.18, fill: color }}>
          {percentage}%
        </text>
        <text x={cx} y={cy + size * 0.1} textAnchor="middle" style={{ fontSize: size * 0.07, fill: "#6B7280" }}>
          {completed}/{total}
        </text>
      </svg>
      <p className="text-sm font-semibold text-[#002F59] mt-1">{label}</p>
    </div>
  );
}
